import { render } from "./PopUpTable.vue?vue&type=template&id=03c474b9"
import script from "./PopUpTable.vue?vue&type=script&lang=js"
export * from "./PopUpTable.vue?vue&type=script&lang=js"

import "./PopUpTable.vue?vue&type=style&index=0&id=03c474b9&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__